import React, { useEffect } from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import ApplicationForm from '../components/ApplicationForm';
import ROLES from '../lib/roles';
import '../styles/home.css';
import '../styles/careers.css';

/*
 * One role, at a permanent URL so it can be posted to a school job board.
 *
 * The facts strip comes before any prose. A student deciding whether to read
 * this at all is deciding on location, hours, and pay, and burying those under
 * a paragraph about the company wastes both sides' time.
 */
function CareersRole() {
  const { slug } = useParams();
  const role = ROLES.find((r) => r.slug === slug);

  // Same approach as BlogPost: one page, one string, no helmet library.
  useEffect(() => {
    if (!role) return;
    const previous = document.title;
    document.title = `${role.title} · Zenbul`;
    return () => {
      document.title = previous;
    };
  }, [role]);

  if (!role) {
    return <Navigate to="/careers" replace />;
  }

  return (
    <>
      <Nav />
      <main className="role wrap role-shell">
        <div className="role-inner">
          <Link to="/careers" className="role-back">
            <span aria-hidden="true">&larr;</span> All roles
          </Link>

          <div className="role-meta">
            <span>{role.kind}</span>
            <span aria-hidden="true">&middot;</span>
            <span>{role.location}</span>
          </div>

          <h1 className="role-title">{role.title}</h1>
          <p className="role-teaser">{role.teaser}</p>

          <dl className="role-facts">
            {role.facts.map((f) => (
              <div className="role-fact" key={f.label}>
                <dt>{f.label}</dt>
                <dd>{f.value}</dd>
              </div>
            ))}
          </dl>

          <div className="role-body">
            <section className="role-section">
              <h2 className="role-section-title">{role.intro.title}</h2>
              {role.intro.paras.map((p) => (
                <p key={p}>{p}</p>
              ))}
            </section>

            <section className="role-section">
              <h2 className="role-section-title">{role.duties.title}</h2>
              <ul className="role-duties">
                {role.duties.items.map((d) => (
                  <li key={d.lead}>
                    <strong>{d.lead}</strong> {d.body}
                  </li>
                ))}
              </ul>
            </section>

            <section className="role-section">
              <h2 className="role-section-title">{role.requirements.title}</h2>
              <ul className="role-bullets">
                {role.requirements.bullets.map((b) => (
                  <li key={b}>{b}</li>
                ))}
              </ul>
            </section>

            <section className="role-section">
              <h2 className="role-section-title">{role.niceToHave.title}</h2>
              <ul className="role-bullets">
                {role.niceToHave.bullets.map((b) => (
                  <li key={b}>{b}</li>
                ))}
              </ul>
            </section>
          </div>
        </div>

        {/* The one part of the page that argues rather than specifies, so it
            gets the dark surface per the site's loud/quiet rule. */}
        <section className="role-closing">
          <h2 className="role-closing-title">{role.closing.title}</h2>
          {role.closing.paras.map((p) => (
            <p className="role-closing-body" key={p}>
              {p}
            </p>
          ))}
        </section>

        <ApplicationForm role={role} />

      </main>
      <Footer />
    </>
  );
}

export default CareersRole;
